import { render, staticRenderFns } from "./ThemeGroupbuyingForm.vue?vue&type=template&id=0d109416&scoped=true&"
import script from "./ThemeGroupbuyingForm.vue?vue&type=script&lang=js&"
export * from "./ThemeGroupbuyingForm.vue?vue&type=script&lang=js&"
import style0 from "./ThemeGroupbuyingForm.vue?vue&type=style&index=0&id=0d109416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d109416",
  null
  
)

export default component.exports